import {StyledProps, React, _, styled, classNames} from '@api'
import {Tooltip2} from '@api'

import { BlueprintCardInPopoverRefactorMe } from '@design-board/components'
import { MenuItem, ListItemText, Checkbox, Tooltip, Dialog, DialogTitle } from '@material-ui/core'
import {withStyles} from '@material-ui/core/styles'
import {Stores} from '@stores'
import { getLibraryDisplayName } from '@utils'
import { MenuDivider, Navbar, NavbarGroup, Button, Spinner, ControlGroup, RadioGroup, Radio,FormGroup } from '@blueprintjs/core'
import * as css from './ExportView.css'
import * as pdfCss from './PdfReportBuilderToolbar.css'
import {observer} from 'mobx-react'

const styles = theme => ({
  modal:        {
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'center'
  },
  paper:        {
    display:         'flex',
    justifyContent:  'center',
    width:           theme.spacing() * 80,
    height:          theme.spacing() * 84,
    backgroundColor: theme.palette.background.paper,
    boxShadow:       theme.shadows[5],
    padding:         0,
    borderRadius:    2,
    flexDirection:   'column',
    fontSize:        24,
    outline:         'none'
  },
  title:        {
    height:         80,
    borderBottom:   '1px solid #dedede',
    width:          '100%',
    display:        'flex',
    justifyContent: 'center',
    alignItems:     'center'
  },
  exportView:   {
    maxWidth: 300
  },
  listWrapper:  {
    width:          '100%',
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'center'
  },
  listItem:     {
    height: 56,
    width:  300
  },
  listItemText: {
    width:        '230px',
    whiteSpace:   'nowrap',
    overflow:     'hidden',
    textOverflow: 'ellipsis'
  },
  footer:       {
    height:         80,
    justifyContent: 'flex-end',
    display:        'flex',
    alignItems:     'center',
    marginRight:    24
  },
  checkbox:     {
    '& svg': {
      width:  20,
      height: 20
    }
  },
  primary: {
    '&:hover': {
      backgroundColor: 'rgb(65, 131, 243) !important'
    }
  },
  icon: {
    margin: '2px'
  },
  cancelButton: {
    marginRight: '10px'
  },
 modalTitle: {
   padding:'unset'
 },
 messageDiv: {
   padding:'5px 0',
   fontSize:'15px'
 },
 dialog: {
   padding:'10px !important'
 },
 disabled: {
  pointerEvents: 'none',
  opacity: 0.4
 }
})
const FieldsGrid = styled.div`
display:grid;
grid-template-columns: 1fr 1fr 1fr;

&:not(:last-child) {
  border-bottom:1px solid var(--border-color);
}

> * {
  min-width: 8em;
}
`


interface MyProps extends StyledProps {
  stores: Partial<Stores>
}

@(withStyles as any)(styles)
@observer
export class ExportView extends React.Component<MyProps> {
  render() {
    const style:any = css, {props: {stores}} = this
    const {vlp: {isVLPView},
      catalog: {libraryTypes},
      export: {onClose, onClickListItem, modalTitle, type, onChangeImageSize, modalOpen, checkImageSizeUnit,
        exportListValue,onDoExport, exportVLPListValue, disableDownload, selectedImageSize, exportProgress, loadingImageSize, exportImagesCount,exportImagesConfig: { smallImageSize, mediumImageSize, largeImageSize } } } = stores
    const {classes, } = this.props

    const exportList = [
      {
        name:  'Products',
        value: 'products'
      }, {
        name:  getLibraryDisplayName(libraryTypes, 'materials'),
        value: 'materials'
      }, {
        name:  getLibraryDisplayName(libraryTypes, 'styles'),
        value: 'styles'
      }, {
        name:  getLibraryDisplayName(libraryTypes, 'colors'),
        value: 'colors'
      }, {
        name:  getLibraryDisplayName(libraryTypes, 'hardware'),
        value: 'hardware'
      }, {
        name:  'Tags',
        value: 'tags'
      }, {
        name:  'Notes',
        value: 'notes'
      }, {
        name:  'Activity',
        value: 'activity'
      }, {
        name:  'Images',
        value: 'images'
      }
    ]
    const exportVLPList = [
      {
        name:  'Colors',
        value: 'merchOptions'
      }, {
        name:  'Products',
        value: 'merchProducts'
      }, {
        name:  'Tags',
        value: 'tags'
      }

    ]

    return (
      <Dialog open={modalOpen}
      className={classNames(css.root, classes.dialog)} >
        <DialogTitle className={classes.modalTitle}>
          <MenuDivider title={modalTitle}/>
        </DialogTitle>
        <BlueprintCardInPopoverRefactorMe className={classes.dialog}>
        {
          type ==='images'?
          <div>
          <div className={classes.messageDiv}>{`Preparing to download (${exportImagesCount >= 0 ? exportImagesCount : `...`}) images to .zip, please choose a file size:`}</div>
            <fieldset>
              <legend>Image Sizes</legend>
              <ControlGroup vertical>
                <FormGroup>
                  <RadioGroup inline disabled={exportProgress}
                              onChange={e => onChangeImageSize(e)}
                              selectedValue={selectedImageSize}
                  >
                    <Radio label={checkImageSizeUnit(smallImageSize,'Small')} value='small'/>
                    <Radio label={checkImageSizeUnit(mediumImageSize,'Medium')} value='medium'/>
                    <Radio label={checkImageSizeUnit(largeImageSize, 'Large')} value='large'/>
                  </RadioGroup>
                </FormGroup>

                </ControlGroup>
            </fieldset>
          </div>:
          <FieldsGrid className={style.fields}>
                {isVLPView ?
                  _.map(exportVLPList, list => (
                    <MenuItem onClick={(e) => { !exportProgress && modalOpen && onClickListItem(e, list.value) }} key={list.value} className={style.field}>
                      <Tooltip2 content={list.name}>
                        <ListItemText className={style.fieldText} classes={{ primary: style.fieldName }}>{list.name}</ListItemText>
                      </Tooltip2>
                      <Checkbox
                        className={style.checkbox}
                        checked={exportVLPListValue[list.value]}
                        disabled={exportProgress}
                      />
                    </MenuItem>
                  ))
                  : _.map(exportList, list => (
                    <MenuItem onClick={(e) => { !exportProgress && modalOpen && onClickListItem(e, list.value) }} key={list.value} className={style.field}>
                      <Tooltip2 content={list.name}>
                        <ListItemText className={style.fieldText} classes={{ primary: style.fieldName }}>{list.name}</ListItemText>
                      </Tooltip2>
                      <Checkbox
                        className={style.checkbox}
                        checked={exportListValue[list.value]}
                        disabled={exportProgress}
                      />
                    </MenuItem>
                  ))
                }
            </FieldsGrid>
        }
      </BlueprintCardInPopoverRefactorMe>
       <Navbar>
          <NavbarGroup align={'right'}>
            <Button className={classes.cancelButton} text='Cancel' minimal={false} onClick={onClose} />
            <Button disabled={loadingImageSize || disableDownload} className={pdfCss.pdfDownloadButton} minimal={false} text='Download' intent='primary'
                    rightIcon={exportProgress ? <Spinner className={classNames(css.spinner, pdfCss.spinner)} size={16} /> : 'download'}
                    onClick={onDoExport}/>
          </NavbarGroup>
        </Navbar>
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/siteHeader/components/ExportView.tsx